import { render, staticRenderFns } from "./InfomationPage.vue?vue&type=template&id=2da56938&scoped=true&"
import script from "./InfomationPage.vue?vue&type=script&lang=js&"
export * from "./InfomationPage.vue?vue&type=script&lang=js&"
import style0 from "./InfomationPage.vue?vue&type=style&index=0&id=2da56938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da56938",
  null
  
)

export default component.exports